import {
  ADD_PROVIDER_IN_USER,
  CREATE_PENDING_USER,
  DELETE_PROVIDER_IN_USER,
  GET_LIST_USERS,
  GET_LOCKED_USERS,
  GET_PENDING_USERS,
  GET_PROVIDER_USERS,
  GET_USER_ROLES,
  REGISTER_PENDING_USER,
  TOGGLE_MFA,
  UNLOCK_USER,
  UPDATE_USER_MFA_STATUS,
  UPDATE_USER_UNLOCK_STATUS,
  USER_DELETE,
  USER_EDIT,
  USER_REGISTER,
  USER_REJECT,
} from "../actions/users";

const INITIAL_STATE = {
  listUsers: {
    isFetching: false,
    didInvalidate: false,
    list: [],
  },
  pendingUsersList: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
  registerPendingUser: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
  createPendingUser: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
  getProviderUsers: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
  userReject: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
  roles: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
  toggleMFA: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
  unlockUser: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
  lockedUsers: {
    isFetching: false,
    didInvalidate: false,
    list: [],
  },
};

const users = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case `${GET_PENDING_USERS}_REJECTED`:
      return {
        ...state,
        pendingUsersList: {
          ...state.pendingUsersList,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${GET_PENDING_USERS}_PENDING`:
      return {
        ...state,
        pendingUsersList: {
          ...state.pendingUsersList,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${GET_PENDING_USERS}_FULFILLED`: {
      return {
        ...state,
        pendingUsersList: {
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    }

    case `${GET_PROVIDER_USERS}_REJECTED`:
      return {
        ...state,
        getProviderUsers: {
          ...state.getProviderUsers,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${GET_PROVIDER_USERS}_PENDING`:
      return {
        ...state,
        getProviderUsers: {
          ...state.getProviderUsers,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${GET_PROVIDER_USERS}_FULFILLED`: {
      return {
        ...state,
        getProviderUsers: {
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    }
    case `${CREATE_PENDING_USER}_REJECTED`:
      return {
        ...state,
        createPendingUser: {
          ...state.createPendingUser,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${CREATE_PENDING_USER}_PENDING`:
      return {
        ...state,
        createPendingUser: {
          ...state.createPendingUser,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${CREATE_PENDING_USER}_FULFILLED`: {
      return {
        ...state,
        createPendingUser: {
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    }
    case `${REGISTER_PENDING_USER}_REJECTED`:
      return {
        ...state,
        registerPendingUser: {
          ...state.registerPendingUser,
          isFetching: false,
          didInvalidate: true,
        }, GET_PROVIDER_USERS
      };
    case `${REGISTER_PENDING_USER}_PENDING`:
      return {
        ...state,
        registerPendingUser: {
          ...state.registerPendingUser,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${REGISTER_PENDING_USER}_FULFILLED`: {
      return {
        ...state,
        registerPendingUser: {
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    }



    case `${GET_LIST_USERS}_REJECTED`:
      return {
        ...state,
        listUsers: {
          ...state.listUsers,
          isFetching: false,
          didInvalidate: true,
          token: false,
        },
      };
    case `${GET_LIST_USERS}_PENDING`:
      return {
        ...state,
        listUsers: {
          ...state.listUsers,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${GET_LIST_USERS}_FULFILLED`: {
      return {
        ...state,
        listUsers: {
          isFetching: false,
          didInvalidate: false,
          list: action.payload.data,
        },
      };
    }
    case `${USER_REGISTER}_REJECTED`:
      return {
        ...state,
        listUsers: {
          ...state.listUsers,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${USER_REGISTER}_PENDING`:
      return {
        ...state,
        listUsers: {
          ...state.listUsers,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${USER_REGISTER}_FULFILLED`:
      return {
        ...state,
        listUsers: {
          ...state.listUsers,
          isFetching: false,
          didInvalidate: false,
        },
      };
    case `${USER_EDIT}_REJECTED`:
      return {
        ...state,
        listUsers: {
          ...state.listUsers,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${USER_EDIT}_PENDING`:
      return {
        ...state,
        listUsers: {
          ...state.listUsers,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${USER_EDIT}_FULFILLED`:
      return {
        ...state,
        listUsers: {
          ...state.listUsers,
          isFetching: false,
          didInvalidate: false,
        },
      };
    case `${USER_DELETE}_REJECTED`:
      return {
        ...state,
        listUsers: {
          ...state.listUsers,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${USER_DELETE}_PENDING`:
      return {
        ...state,
        listUsers: {
          ...state.listUsers,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${USER_DELETE}_FULFILLED`:
      const listUsers = [...state.listUsers.list];

      var removeIndex = listUsers
        .map((p) => {
          return p.email;
        })
        .indexOf(action.payload.user.Email);

      listUsers.splice(removeIndex, 1);
      return {
        ...state,
        listUsers: {
          ...state.listUsers,
          isFetching: false,
          didInvalidate: false,
          list: listUsers,
        },
      };
    case `${USER_REJECT}_REJECTED`:
      return {
        ...state,
        userReject: {
          ...state.userReject,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${USER_REJECT}_PENDING`:
      return {
        ...state,
        userReject: {
          ...state.userReject,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${USER_REJECT}_FULFILLED`: {
      return {
        ...state,
        userReject: {
          ...state.userReject,
          isFetching: false,
          didInvalidate: false,
        },
      };
    }
    case `${ADD_PROVIDER_IN_USER}_REJECTED`:
      return {
        ...state,
        listUsers: {
          ...state.listUsers,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${ADD_PROVIDER_IN_USER}_PENDING`:
      return {
        ...state,
        listUsers: {
          ...state.listUsers,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${ADD_PROVIDER_IN_USER}_FULFILLED`: {
      return {
        ...state,
        listUsers: {
          ...state.listUsers,
          isFetching: false,
          didInvalidate: false,
        },
      };
    }
    case `${DELETE_PROVIDER_IN_USER}_REJECTED`:
      return {
        ...state,
        listUsers: {
          ...state.listUsers,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${DELETE_PROVIDER_IN_USER}_PENDING`:
      return {
        ...state,
        listUsers: {
          ...state.listUsers,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${DELETE_PROVIDER_IN_USER}_FULFILLED`: {
      const listUsers = state.listUsers.list;

      const user = listUsers.find((u) => u.id === action.payload.userId);

      const providerList = [...user.prestadores];

      const removeIndex = providerList
        .map((provider) => provider.id)
        .indexOf(action.payload.providerId);

      providerList.splice(removeIndex, 1);
      user.prestadores = providerList;

      return {
        ...state,
        listUsers: {
          ...state.listUsers,
          isFetching: false,
          didInvalidate: false,
          list: listUsers,
        },
      };
    }
    case `${GET_USER_ROLES}_REJECTED`:
      return {
        ...state,
        roles: {
          ...state.roles,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${GET_USER_ROLES}_PENDING`:
      return {
        ...state,
        roles: {
          ...state.roles,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${GET_USER_ROLES}_FULFILLED`: {
      return {
        ...state,
        roles: {
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    }
    case `${TOGGLE_MFA}_REJECTED`:
      return {
        ...state,
        toggleMFA: {
          ...state.toggleMFA,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${TOGGLE_MFA}_PENDING`:
      return {
        ...state,
        toggleMFA: {
          ...state.toggleMFA,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${TOGGLE_MFA}_FULFILLED`: {
      return {
        ...state,
        toggleMFA: {
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    }
    case `${UNLOCK_USER}_REJECTED`:
      return {
        ...state,
        unlockUser: {
          ...state.unlockUser,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${UNLOCK_USER}_PENDING`:
      return {
        ...state,
        unlockUser: {
          ...state.unlockUser,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${UNLOCK_USER}_FULFILLED`: {
      return {
        ...state,
        unlockUser: {
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    }
    case `${GET_LOCKED_USERS}_REJECTED`:
      return {
        ...state,
        lockedUsers: {
          ...state.lockedUsers,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${GET_LOCKED_USERS}_PENDING`:
      return {
        ...state,
        lockedUsers: {
          ...state.lockedUsers,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${GET_LOCKED_USERS}_FULFILLED`:
      return {
        ...state,
        lockedUsers: {
          isFetching: false,
          didInvalidate: false,
          list: action.payload.data,
        },
      };
    case `${UPDATE_USER_UNLOCK_STATUS}`:
      return {
        ...state,
        lockedUsers: {
          ...state.lockedUsers,
          list: state.lockedUsers.list.filter((user) =>
            user.id !== action.payload.userId
          ),
        },
      }
    case UPDATE_USER_MFA_STATUS:
      const listUsersMfa = [...state.listUsers.list];
      const indexMfa = listUsersMfa.findIndex(
        (u) => u.id === action.payload.userId,
      );
      if (indexMfa !== -1) {
        listUsersMfa[indexMfa].twoFactorEnabled = action.payload.mfaEnabled;
      }
      return {
        ...state,
        listUsers: {
          ...state.listUsers,
          list: listUsersMfa,
        },
      };
    default:
      return state;
  }
};

export default users;
